import { ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { SIDEBAR_EXPANDED_WIDTH } from '@watershed/shared-universal/utils/constants';

import SettingsCommandButton from '../commandPalette/SettingsCommandButton';
import { useSettingsCommandPalette } from '../commandPalette/useSettingsCommandPalette';
import { SEARCH_BAR_HEIGHT } from '../utils/constants';

const layoutStyles: SxProps<Theme> = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginLeft: `${SIDEBAR_EXPANDED_WIDTH}px`,
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    marginRight: 0,
    height: '100%',
    marginTop: '48px',
  },
});

const mainStyles: SxProps<Theme> = (theme) => ({
  position: 'relative',
  display: 'flex',
  // Used to center the loading spinner on page load.
  alignItems: 'center',
  justifyContent: 'center',
  borderLeft: `0.5px solid ${theme.palette.grey30}`,
  borderTop: `0.5px solid ${theme.palette.grey30}`,
  backgroundColor: theme.palette.grey05,
  height: `calc(100dvh - ${SEARCH_BAR_HEIGHT}px)`,
  width: 'fill-available',
  overflow: 'hidden',
  zIndex: 1,
  boxShadow: `0px 1px 2px 0px ${theme.palette.grey100}10, 0px 0px 24px -2px ${theme.palette.grey100}05`,
  [theme.breakpoints.down('md')]: {
    borderLeft: 'none',
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
  },
});

const searchWrapperStyles: SxProps<Theme> = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    width: 'fit-content',
    position: 'fixed',
    top: 8,
    right: 8,
  },
});

// This component initializes the settings command palette
function SettingsCommandPaletteInitializer() {
  useSettingsCommandPalette();
  return null;
}

type SettingsLayoutProps = {
  children: ReactNode;
};

function Layout({ children }: SettingsLayoutProps) {
  return (
    <>
      <SettingsCommandPaletteInitializer />
      <Stack sx={layoutStyles}>
        <Stack sx={searchWrapperStyles}>
          <SettingsCommandButton />
        </Stack>
        <Box component="main" sx={mainStyles}>
          {children}
        </Box>
      </Stack>
    </>
  );
}

export const SettingsLayout = {
  Layout,
};
